import { combineReducers } from 'redux';
import commonReducers from '../../common/reducers';

export const reducers = combineReducers(commonReducers);

export type RelatedPostsWidgetState = ReturnType<typeof reducers>;
